const WRITE_TARGETS = Object.freeze({
  firestore: 'firestore',
  api: 'api'
});

export function normalizeWriteTarget(value, fallback = WRITE_TARGETS.firestore) {
  const target = String(value || '').trim().toLowerCase();
  return target === WRITE_TARGETS.api ? WRITE_TARGETS.api : fallback;
}

export function parseWriteOperationTargets(value) {
  const map = {};
  const text = String(value || '').trim();
  if (!text) {
    return map;
  }

  text.split(',').forEach(entry => {
    const [operation, target] = entry.split(':').map(item => String(item || '').trim());
    if (!operation) {
      return;
    }
    map[operation] = normalizeWriteTarget(target);
  });
  return map;
}

export function resolveWriteRepo({ routing, operation, firestoreRepo, apiRepo, scopeName = 'Repository' }) {
  const target = normalizeWriteTarget(
    routing?.operationTargets?.[operation] || routing?.defaultTarget
  );
  const repo = target === WRITE_TARGETS.api ? apiRepo : firestoreRepo;
  if (!repo || typeof repo[operation] !== 'function') {
    throw new Error(`${scopeName} write target "${target}" does not implement ${operation}`);
  }
  return repo;
}

export function parseRoutingFromEnv({
  env = process.env,
  defaultTargetKeys = [],
  operationTargetsKeys = []
}) {
  const operationTargetsValue = operationTargetsKeys.find(key => String(env[key] || '').trim());
  const defaultTargetValue = defaultTargetKeys.find(key => String(env[key] || '').trim());
  return {
    defaultTarget: normalizeWriteTarget(defaultTargetValue ? env[defaultTargetValue] : WRITE_TARGETS.firestore),
    operationTargets: parseWriteOperationTargets(operationTargetsValue ? env[operationTargetsValue] : '')
  };
}
